// extracted by mini-css-extract-plugin
export default {"OngoingCasesPortletStub":"index__OngoingCasesPortletStub__JjUw3"};